import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import RankBlock from "../../components/RankBlock";
import { useSnackbar } from "notistack";
import moment from "moment";
import { getSensorEventLive } from "../../apis/SensorEvent.Api";

const DailyEventRank = ({ selectedBuilding }) => {
    const userData = useSelector((state) => state.userData.data);
    const rooms = useSelector((state) => state.room.data);

    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(false);
    const [dateType, setDateType] = useState("TODAY"); // TODAY, YESTERDAY, WEEK, MONTH
    const [rankDataArray, setRankDataArray] = useState([
        {
            number: 0,
            name: " --- ",
        },
        {
            number: 0,
            name: " --- ",
        },
        {
            number: 0,
            name: " --- ",
        },
    ]);

    async function getRankData() {
        setIsLoading(true);
        try {
            const realRooms = Object.values(rooms)
                .filter((room) => room.buildingId === selectedBuilding)
                .map((room) => room.roomId);

            const raw_ds = {};
            realRooms.forEach((roomId) => {
                raw_ds[roomId] = [roomId, 0];
            });

            const startObj =
                dateType === "YESTERDAY"
                    ? moment().subtract(1, "days")
                    : dateType === "WEEK"
                    ? moment().subtract(7, "days")
                    : dateType === "MONTH"
                    ? moment().subtract(1, "months")
                    : moment();

            const res = await getSensorEventLive({
                room_id: JSON.stringify(realRooms),
                start_time: moment(startObj.startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")).format("YYMMDDHHmmssSSS"),
                end_time: moment(moment().endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")).format("YYMMDDHHmmssSSS"),
            });
            if (!res.data.indicator) {
                enqueueSnackbar(res.data.message, { variant: "error" });
                setIsLoading(false);
                return;
            }

            const rankData = res.data.message;

            rankData.forEach((data) => {
                raw_ds[data.room_id][1]++;
            });

            const sorted_ds = Object.values(raw_ds).sort((a, b) => b[1] - a[1]);

            setRankDataArray(
                sorted_ds.slice(0, 3).map((data) => ({
                    number: data[1],
                    name: data[0],
                }))
            );
        } catch (error) {
            enqueueSnackbar(error.data.message, { variant: "error" });
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getRankData();
    }, [selectedBuilding, dateType]);

    return (
        <RankBlock
            className="daily-event-rank"
            rankDataArray={rankDataArray}
            dateType={dateType}
            setDateType={setDateType}
            isLoading={isLoading}
        />
    );
};

export default DailyEventRank;
